import { useQuery } from '@tanstack/react-query'
import { getPlanAndRateOverrideRule } from '../../../api/plan-and-rate-override-rules-api'

export const PLAN_AND_RATE_OVERRIDE_RULE_QUERY_KEY =
  'plan-and-rate-override-rule'

export function useGetPlanAndRateOverrideRule(id?: string) {
  return useQuery({
    queryKey: [PLAN_AND_RATE_OVERRIDE_RULE_QUERY_KEY, id],
    queryFn: () => getPlanAndRateOverrideRule(id as string),
    enabled: Boolean(id),
    staleTime: 30_000,
  })
}
